import AllocatorInfoProfile from './AllocatorInfoProfile'

export default AllocatorInfoProfile
